import * as React from 'react'
import { Button, ErrorMessage } from '../../../../components/UI'
import { productShortCodes } from '../../../../lib/constants'
import { useI18n, useTranslation } from '../../../../lib/context/i18n'
import { isServer } from '../../../../lib/utils'
import { useParams, useRegistrationContext } from '../../context/registration'
import { NewStyled as ParentStyled } from '../../styled'
import { DownloadList } from './DownloadList'
import { useDownloads } from './hooks'
import { LicensesList } from './LicenseList'
import { Styled } from './styled'
import useDLProductKitViewed from '../../../../lib/hooks/tracking/useDLProductKitViewed'
import { useSignupContext } from '../../context/signup'

export const Downloads = () => {
  const t = useTranslation()
  const { blok } = useRegistrationContext()
  const { setIsAuthenticated, goto } = useRegistrationContext()
  const { getTranslatedUrlFromLink } = useI18n()

  const {
    productName,
    operatingSystem,
  } = useSignupContext()

  // remove first letter from string
  const code = React.useMemo(() => {
    // example _PDFSDK that is why we slice for the first letter _
    if (!operatingSystem) return productName.slice(1);
    return operatingSystem
  }, [productName, operatingSystem])

  const downloads = useDownloads({ code, name: productName })

  useDLProductKitViewed()

  const logout = React.useCallback(() => {
    setIsAuthenticated(false)
    if (window && !isServer()) {
      window.localStorage.removeItem('token')
    }
    goto('/')
  }, [setIsAuthenticated, goto])

  const productData = productShortCodes.find(p => p.value === productName)

  if (!productData || !blok) return null

  return (
    <>
      <ParentStyled.CardHeader>
        <ParentStyled.CardTitle>Download evaluation version</ParentStyled.CardTitle>
        <ParentStyled.CardSubline>{productData?.name}</ParentStyled.CardSubline>
      </ParentStyled.CardHeader>
      {downloads.error && (
        <ErrorMessage downloadsError={downloads.error} $variant="light">
          {t(downloads.error)}
        </ErrorMessage>
      )}
      <Styled.Content>
        <DownloadList loading={downloads.loading} kits={downloads.kits} />
        <LicensesList loading={downloads.loading} licenses={downloads.licenses} />
      </Styled.Content>
      <ParentStyled.CardFooter>
        <ParentStyled.CardFooterGroup>
          {blok.contactLink && (
            <Button
              as="a"
              href={getTranslatedUrlFromLink(blok.contactLink)}
              target="_blank"
              rel="nofollow noreferrer"
              $variant="primary"
              $inverted
              iconRight="arrow-right"
            >
              {t('CONTACT_SALES')}
            </Button>
          )}
          <Button $variant="secondary" onClick={() => goto('/')} $inverted iconLeft="refresh">
            {t('CHANGE_PRODUCT')}
          </Button>
        </ParentStyled.CardFooterGroup>
        <ParentStyled.CardFooterGroup>
          <Button onClick={logout} $variant="tertiary" $inverted iconRight="logout">
            {t('LOGOUT')}
          </Button>
        </ParentStyled.CardFooterGroup>
      </ParentStyled.CardFooter>
    </>
  )
}
